import PropTypes from 'prop-types';
import React from 'react';
import { Autocomplete, InputAdornment, TextField } from '@mui/material';
import ProfileIcon from '@mui/icons-material/Storage';

class ProfileList extends React.Component {

  static propTypes = {
    profiles: PropTypes.array,
    value: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    autoFocus: PropTypes.bool,
    label: PropTypes.any,
    id: PropTypes.string,
    fullWidth: PropTypes.bool,
    clearable: PropTypes.bool
  };

  render () {
    const { value, profiles, onChange, label, autoFocus, disabled, id, fullWidth, clearable } = this.props;
    const selectedProfile = profiles?.find(p => p?.profileName === value);

    return (
      <Autocomplete
        id={id || 'profileName'}
        name="profileName"
        value={value}
        onChange={onChange}
        size="small"
        variant="outlined"
        spellCheck="false"
        className={'profile' + (!selectedProfile ? ' empty' : '') + (selectedProfile?.params?.isTraining ? ' trainingProfile' : '') + (selectedProfile?.params?.isProduction ? ' productionProfile' : '')}
        options={profiles?.filter(p => p !== undefined)}
        disabled={!!disabled}
        renderInput={(params) => <TextField {...params}
          label={label}
          autoFocus={ !!autoFocus }
          style={{ width: !fullWidth ? `${Math.max(12 + selectedProfile?.params?.displayName?.length, 16)}ch` : '100%' }}
          InputProps={{
            ...params?.InputProps,
            ...value && {
              startAdornment: (
              <InputAdornment position="start">
                <ProfileIcon />
              </InputAdornment>
              )
            }
          }
        }/>}
        disableClearable={!clearable}
        forcePopupIcon
        isOptionEqualToValue={(option, value) => {
          return option?.profileName === value;
        }}
        slotProps={
          {
            popper: {
              className: 'profileList'
            }
          }
        }
        getOptionLabel={(option) => {
          let entry;
          if (option?.profileName) {
            entry = option;
          } else {
            entry = profiles?.find(p => p?.profileName === option);
          }
          return entry?.params?.displayName || option;
        }
        }
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          let entry;
          if (option?.profileName) {
            entry = option;
          } else {
            entry = profiles?.find(p => p?.profileName === option);
          }
          return <li key={key} tabIndex="-1" role="option" className="MuiAutocomplete-option" {...optionProps}>
            {entry
              ? <div className={'profile ' + entry.profileName}>
                  <div>{entry.params?.displayName}</div>
                  <div className='profileTypes'>
                    {entry.params?.isProduction &&
                      <span className="productionProfile">Prod</span>
                    }
                    {entry.params?.isTraining &&
                      <span className="trainingProfile">Train</span>
                    }
                  </div>
                </div>
              : ''
            }
            </li>;
        }}
      />
    );
  }

}

export default ProfileList;
